"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIConsumer = exports.uiContext = void 0;

var react_1 = __importStar(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var FilterWrapper_1 = __importDefault(require("./FilterWrapper"));

var SearchWrapper_1 = __importDefault(require("./SearchWrapper"));

var ItemList_1 = __importDefault(require("./ItemList"));

var getFiltersByComponentList_1 = require("./getFiltersByComponentList");

var getFilteredComponents_1 = require("./getFilteredComponents");

var uiContext_1 = __importStar(require("./uiContext"));

exports.uiContext = uiContext_1.default;

var ComponentDisplayMode_1 = require("../FlowContainer/ComponentDisplayMode");

var uiContext_2 = require("./uiContext");

Object.defineProperty(exports, "defaultUI", {
  enumerable: true,
  get: function get() {
    return uiContext_2.defaultUI;
  }
});

var applyMandatoryCategories = function applyMandatoryCategories(components, mandatoryCategories) {
  mandatoryCategories.forEach(function (mandatoryCategory) {
    components.forEach(function (component) {
      if (!(mandatoryCategory in component.categories)) {
        // eslint-disable-next-line no-param-reassign
        component.categories[mandatoryCategory] = ['N/A'];
      }
    });
  });
};
/**
 * reduce filters so that filter is picked
 * when at least one of it's terms applies or associated with ALL of the components
 * @param filters
 * @param components
 */


var reduceFilters = function reduceFilters(filters, components) {
  return lodash_1.pickBy(filters, function (value, category) {
    return components.every(function (component) {
      return category in component.categories;
    });
  });
};
/*
 * Implementation of djb2 xor algorithm to hash strings.
 *
 * @see http://www.cse.yorku.ca/~oz/hash.html
 * @see https://gist.github.com/eplawless/52813b1d8ad9af510d85
 */


var hash = function hash(str) {
  var h = 5381;

  for (var i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    h = h * 33 ^ str.charCodeAt(i);
  } // eslint-disable-next-line no-bitwise


  return h >>> 0;
};

var ComponentSelector = function ComponentSelector(props) {
  var allComponents = props.components,
      ui = props.ui,
      onSelect = props.onSelect,
      mandatoryCategories = props.mandatoryCategories;
  var allComponentsNames = allComponents.map(function (Component) {
    return typeof Component === 'string' ? Component : Component.displayName;
  });
  var keySuffix = hash(allComponentsNames.sort().join().trim());
  var localStorageKey = "bodiless.componentLibrary.activeFilters." + keySuffix;

  var _a = core_1.useLocalStorage(localStorageKey, []),
      activeFilters = _a[0],
      setActiveFilters = _a[1];

  var _b = react_1.useState(''),
      activeSearch = _b[0],
      setActiveSearch = _b[1];

  if (mandatoryCategories) {
    applyMandatoryCategories(allComponents, mandatoryCategories);
  }

  var newCompRender = getFilteredComponents_1.getFilteredComponents(allComponents, activeFilters, activeSearch);
  var allFilters = getFiltersByComponentList_1.getFiltersByComponentList(allComponents);
  var filters = reduceFilters(getFiltersByComponentList_1.getFiltersByComponentList(newCompRender), newCompRender);

  var finalUI = __assign(__assign(__assign({}, uiContext_1.defaultUI), core_1.useMenuOptionUI()), ui);

  return react_1.default.createElement(ComponentDisplayMode_1.ComponentDisplayModeProvider, {
    mode: ComponentDisplayMode_1.ComponentDisplayMode.ComponentSelector
  }, react_1.default.createElement(uiContext_1.default.Provider, {
    value: finalUI
  }, react_1.default.createElement(finalUI.MasterWrapper, null, Object.getOwnPropertyNames(allFilters).length > 0 && react_1.default.createElement(finalUI.FlexSection, null, react_1.default.createElement(finalUI.ComponentLinkWrapper, {
    disabled: activeFilters.length === 0,
    onClick: function onClick() {
      if (activeFilters.length !== 0 || activeSearch.length !== 0) {
        setActiveSearch('');
        setActiveFilters([]);
      }
    }
  }, "Clear"), react_1.default.createElement(FilterWrapper_1.default, {
    activeFilter: activeFilters,
    setActiveFilters: setActiveFilters,
    allfilters: allFilters,
    filters: filters
  })), react_1.default.createElement(finalUI.FlexSectionFull, null, react_1.default.createElement(SearchWrapper_1.default, {
    activeSearch: activeSearch,
    setActiveSearch: setActiveSearch
  }), react_1.default.createElement(ItemList_1.default, {
    onSelect: onSelect,
    components: newCompRender
  })))));
};

var TextFormatList = function TextFormatList(props) {
  var components = props.components,
      onSelect = props.onSelect;
  var elems = components.map(function (Component, index) {
    return react_1.default.createElement("button", {
      type: "submit",
      onClick: function onClick() {
        return onSelect([Component.displayName]);
      },
      key: index.toString()
    }, react_1.default.createElement(Component, null, Component.description || Component.name));
  });
  return react_1.default.createElement(react_1.default.Fragment, null, elems);
};

TextFormatList.propTypes = {
  components: prop_types_1.default.arrayOf(prop_types_1.default.any).isRequired,
  onSelect: prop_types_1.default.func.isRequired
};
exports.default = ComponentSelector;
exports.UIConsumer = uiContext_1.default.Consumer;